import { isValidPhoneNumber as isValidPhoneNumberLib, parsePhoneNumberWithError } from 'libphonenumber-js';

export const e164Format = (phone) => {
    try {
        const phoneInstance = parsePhoneNumberWithError(phone, 'US');
        return phoneInstance.format('E.164');
    } catch {
        return null;
    }
};

export const isValidPhoneNumber = (phone) => {
    if (phone === undefined || phone === null) {
        return false;
    }

    try {
        return isValidPhoneNumberLib(phone, 'US');
    } catch {
        return false;
    }
};

export const phoneCountry = (phone) => {
    try {
        return parsePhoneNumberWithError(phone, 'US').country ?? null;
    } catch {
        return null;
    }
};

// Mirrors the backend App\Utilities\Messaging\PhoneNumberUtil::isTollFree() prefix set so the
// client-side guard and the server-side rejection agree. Expects an E.164 string.
export const isTollFreePhoneNumber = (e164) => /^\+1(800|822|833|844|855|866|877|888)/.test(e164 ?? '');
